"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEndpoint = exports.createEndpointFactory = exports.EndpointBodyType = void 0;
var EndpointBodyType;
(function (EndpointBodyType) {
    EndpointBodyType["PROPERTY"] = "property";
    EndpointBodyType["BODY"] = "body";
})(EndpointBodyType = exports.EndpointBodyType || (exports.EndpointBodyType = {}));
function createEndpointFactory(factory) {
    return factory;
}
exports.createEndpointFactory = createEndpointFactory;
function createEndpoint(endpoint) {
    if (!endpoint.method) {
        endpoint.method = 'get';
    }
    if (!endpoint.bodyType) {
        endpoint.bodyType = EndpointBodyType.PROPERTY;
    }
    return endpoint;
}
exports.createEndpoint = createEndpoint;
//# sourceMappingURL=Endpoint.js.map